export default function ReadinessRing({ value = 0, label, sublabel, size = 116, strokeWidth = 10, testid }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, value));
  const offset = circumference - (clamped / 100) * circumference;
  const low = clamped < 60;

  return (
    <div
      className="flex flex-col items-center gap-2"
      data-testid={testid}
      aria-label={`${label}: prontezza ${clamped}%${low ? ", sotto il 60%" : ""}`}
      role="img"
    >
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--hairline)"
            strokeWidth={strokeWidth}
          />
          <circle
            className="ring-progress"
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--volt)"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono font-semibold text-xl tracking-tight" data-testid={testid ? `${testid}-value` : undefined}>
            {clamped}%
          </span>
        </div>
      </div>
      <div className="text-center">
        <p className="font-mono text-[11px] tracking-widest uppercase font-semibold">{label}</p>
        {sublabel && <p className="text-[11px] text-[color:var(--text-2)] max-w-[120px] leading-4 mt-0.5">{sublabel}</p>}
      </div>
    </div>
  );
}
